import { render, staticRenderFns } from "./AmpSetup.vue?vue&type=template&id=1b3daf64&scoped=true&"
import script from "./AmpSetup.vue?vue&type=script&lang=js&"
export * from "./AmpSetup.vue?vue&type=script&lang=js&"
import style0 from "./AmpSetup.vue?vue&type=style&index=0&id=1b3daf64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3daf64",
  null
  
)

export default component.exports